// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"350b51f8","453":"46df2c02","455":"c9c94020","977":"26779de3"}[chunkId] + ".chunk.js";
};